import { Component, Input, OnInit } from '@angular/core';

export enum ToolTipPosition {
  Below,
  Above,
  Left,
  Right,
}

@Component({
  selector: 'cds-tool-tip',
  templateUrl: './tool-tip.component.html',
  styleUrls: ['./tool-tip.component.scss'],
})
export class ToolTipComponent implements OnInit {
  @Input() message: string;
  @Input() toolTipClass = 'tooltiptext'; // not used anymore need to remove from other components
  ToolTipPosition = ToolTipPosition;
  @Input() visiblePosition: ToolTipPosition = ToolTipPosition.Below; // todo build out right
  constructor() {}

  ngOnInit() {}
}
